const team2021 = {
  title: "2021",
  members: [
    {
      name: "message.team.management",
      members: [
        {
          img: "/static/team/members/daniel_gavrila.jpg",
          fullName: "Daniel Gavrila",
          role: "message.team.roles.captain",
          mail: "d.gavrila.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/steve_groleau.jpg",
          fullName: "Steve Groleau",
          role: "message.team.roles.technical-director",
          mail: "s.groleau.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/simon_aubin_lavoie.jpg",
          fullName: "SIMON AUBIN-LAVOIE",
          role: "message.team.roles.management-director",
          mail: "s.aubinlavoie.formule.ets@gmail.com",
          linkedin: "",
        },
      ],
    },
    {
      name: "message.team.aerodynamic",
      members: [
        {
          img: "/static/team/members/xavier_brien.jpg",
          fullName: "XAVIER BRIEN",
          role: "message.team.roles.head-aerodynamics",
          mail: "x.brien.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/daniel_gavrila.jpg",
          fullName: "Daniel Gavrila",
          role: "",
          mail: "d.gavrila.formule.ets@gmail.com",
          linkedin: "",
        },
      ],
    },
    {
      name: "message.team.chassis",
      members: [
        {
          img: "/static/team/members/samuel_gagne.jpg",
          fullName: "SAMUEL GAGNÉ",
          role: "message.team.roles.head-chassis",
          mail: "s.gagne.formule.ets@gmail.com",
          linkedin: "",
        },
      ],
    },
    {
      name: "message.team.dynamics",
      members: [
        {
          img: "/static/team/members/alexandre_valsorda.jpg",
          fullName: "ALEXANDRE VALSORDA",
          role: "message.team.roles.heade-dynamic",
          mail: "a.valsorda.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/ivaylo_pektov.jpg",
          fullName: "IVAYLO PETKOV",
          role: "",
          mail: "i.petkov.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/olivier_lefebvre.jpg",
          fullName: "OLIVIER LEFEBVRE",
          role: "",
          mail: "o.lefebvre.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/lea_bruneau.jpg",
          fullName: "LÉA BRUNEAU",
          role: "",
          mail: "l.bruneau.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/karl_vreeze.jpg",
          fullName: "KARL DE VREEZE",
          role: "",
          mail: "k.devreeze.formule.ets@gmail.com",
          linkedin: "",
        },
      ],
    },
    {
      name: "message.team.electronics",
      members: [
        {
          img: "/static/team/members/victor_avezard.jpg",
          fullName: "VICTOR AVEZARD",
          role: "message.team.roles.head-electronic",
          mail: "v.avezard.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/marc_antoine.jpg",
          fullName: "MARC-ANTOINE DOYON",
          role: "",
          mail: "ma.doyon.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/felix_groleau.jpg",
          fullName: "FELIX GROLEAU",
          role: "",
          mail: "f.groleau.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/komi_kevin.jpg",
          fullName: "KOMI KEVIN AWATOR",
          role: "",
          mail: "k.awator.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/felix_paquet.jpg",
          fullName: "FÉLIX PAQUET",
          role: "",
          mail: "f.paquet.formule.ets@gmail.com",
          linkedin: "",
        },
      ],
    },
    {
      name: "message.team.power_n_drive",
      members: [
        {
          img: "/static/team/members/steve_groleau.jpg",
          fullName: "Steve Groleau",
          role: "message.team.roles.lead-powertrain",
          mail: "s.groleau.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/alexandre_martin.jpg",
          fullName: "ALEXANDRE MARTIN",
          role: "",
          mail: "alexandre.martin.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/jean_carlo.jpg",
          fullName: "JEAN-CARLO DORAY",
          role: "",
          mail: "jc.doray.formule.ets@gmail.com",
          linkedin: "",
        },
      ],
    },
    {
      name: "message.team.machining",
      members: [
        {
          img: "/static/team/members/steve_groleau.jpg",
          fullName: "Steve Groleau",
          role: "",
          mail: "s.groleau.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/alexandre_valsorda.jpg",
          fullName: "ALEXANDRE VALSORDA",
          role: "",
          mail: "a.valsorda.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/jerome_brideau.jpg",
          fullName: "JÉRÔME BRIDEAU",
          role: "",
          mail: "j.brideau.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/samuel_gagne.jpg",
          fullName: "SAMUEL GAGNÉ",
          role: "",
          mail: "s.gagne.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/jimmy_jr.jpg",
          fullName: "JIMMY JR OZAETA",
          role: "",
          mail: "j.ozaeta.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/xavier_brien.jpg",
          fullName: "XAVIER BRIEN",
          role: "",
          mail: "x.brien.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/olivier_lefebvre.jpg",
          fullName: "OLIVIER LEFEBVRE",
          role: "",
          mail: "o.lefebvre.formule.ets@gmail.com",
          linkedin: "",
        },
      ],
    },
    {
      name: "message.team.sponsors_n_media",
      members: [
        {
          img: "/static/team/members/minh_dat.jpg",
          fullName: "MINH DAT QUACH",
          role: "message.team.roles.head-media-sponsors",
          mail: "m.quach.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/jimmy_jr.jpg",
          fullName: "JIMMY JR OZAETA",
          role: "",
          mail: "j.ozaeta.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/melina_gasparini.jpg",
          fullName: "MÉLINA GASPARINI",
          role: "",
          mail: "m.gasparini.formule.ets@gmail.com",
          linkedin: "",
        },
      ],
    },
  ],
};

export default team2021;
